<template>
  <Menu v-if="filteredOrganizations.length > 0" as="div" class="w-full cursor-pointer">
    <MenuButton v-slot="{ open }" as="div" class="w-full">
      <div
        class="group bg-surface-container-low text-on-surface relative mb-0.5 flex w-full items-center justify-between gap-4 overflow-hidden px-6 py-4"
        :class="open ? 'rounded-t-extra-large' : 'shadow-1 rounded-full'"
      >
        <p class="text-label-large">
          {{ open ? $t('organization.showLess') : $t('organization.showMore') }}
        </p>
        <Icon class="transition-all" :class="open && 'rotate-180'">arrow_drop_down</Icon>
        <BaseStateLayer type="surface-neutral" />
      </div>
    </MenuButton>
    <MenuItems
      as="div"
      class="rounded-b-extra-large flex max-h-52 w-full flex-col gap-0.5 overflow-y-auto outline-none"
    >
      <MenuItem v-for="organization of filteredOrganizations" :key="organization.id">
        <button
          @click="
            organization.id == organizationStore.currentOrganization.id
              ? null
              : switchOrganizationAndCloseDialog(organization.id)
          "
          class="group bg-surface-container-low rounded-extra-small text-label-large relative flex w-full shrink-0 cursor-pointer items-center gap-2 overflow-hidden px-6 py-2 text-left"
        >
          <div
            class="bg-secondary-container text-on-secondary-container flex h-8 w-8 items-center justify-center rounded-full"
          >
            {{ organization.name[0] }}
          </div>
          {{ organization.name }}
          <BaseStateLayer type="surface-neutral" />
        </button>
      </MenuItem>
      <MenuItem>
        <button
          @click="onLogout"
          class="group bg-surface-container-low rounded-extra-small text-label-large relative flex w-full shrink-0 cursor-pointer items-center gap-2 overflow-hidden px-6 py-3 text-left"
        >
          <Icon class="text-primary" size="22">logout</Icon>{{ $t('app.logout') }}
          <BaseStateLayer type="surface-neutral" />
        </button>
      </MenuItem>
    </MenuItems>
  </Menu>
  <BaseTextButton v-else color="outlined" icon="logout" size="XS" @click="onLogout">
    {{ $t('app.logout') }}
  </BaseTextButton>
</template>

<script setup lang="ts">
  import { Menu, MenuButton, MenuItems, MenuItem } from '@headlessui/vue'
  import { computed } from 'vue'

  import Icon from '@/core/components/base/icon/BaseIcon.vue'
  import { useOrganizationStore } from '../../../stores/organization.store'
  import { useAuthStore } from '../../../stores/auth.store'
  import BaseStateLayer from '@/core/components/base/state-layer/BaseStateLayer.vue'
  import BaseTextButton from '@/core/components/base/button/text-button/BaseTextButton.vue'
  import { useRouter } from 'vue-router'
  import { ApplicationModule } from '@/core/models/organization'

  const router = useRouter()
  const organizationStore = useOrganizationStore()

  const authStore = useAuthStore()

  const emit = defineEmits<{
    (e: 'closeDialog'): void
  }>()

  const switchOrganizationAndCloseDialog = async (organizationId: string) => {
    await organizationStore.switchOrganization(organizationId)
    emit('closeDialog')

    if (!organizationStore.currentOrganization.modules.includes(ApplicationModule.EDUCATION)) {
      router.replace('/')
      router.go(0)
    } else {
      router.replace('/edu')
      router.go(0)
    }
  }

  const filteredOrganizations = computed(() =>
    organizationStore.organizations.filter(
      (organization) => organization.id != organizationStore.currentOrganization.id,
    ),
  )

  const onLogout = async () => {
    await authStore.logout()
  }
</script>
